/* *************************************************************** *
 * THIS IS AN AUTO GENERATED FILE. PLEASE DO NOT EDIT IT DIRECTLY.
 *
 * If you want to change this Icon component , it is generated
 * from the `iconTamplate.js` file the parent directory.
 * *************************************************************** */
/* eslint-disable */
import React from 'react';
import { useFela, } from 'react-fela';
import iconStyle from '../iconStyle';
import { iconPropTypes, iconDefaultProps, } from '../iconPropTypes';

export default function IconScatterchart({ size, fill, color, attrs, miscStyles, ...props }) {
  const className = useFela({ size, fill, color, miscStyles, }).css(iconStyle);

  return (
    <svg width="1em" height="1em" viewBox="0 0 256 256" className={className} {...props} {...attrs} data-test="IconScatterchart">  <path fill="currentColor" d="M111.705 100.203c-2.061 0-4.052.266-5.984.696-2.28-12.888-13.473-22.696-27.016-22.696-15.188 0-27.5 12.312-27.5 27.5 0 15.187 12.312 27.5 27.5 27.5 2.061 0 4.052-.266 5.984-.696 2.28 12.887 13.473 22.696 27.016 22.696 15.188 0 27.5-12.313 27.5-27.5 0-15.188-12.311-27.5-27.5-27.5z" />  <circle fill="currentColor" cx={177.705} cy={83.703} r={27.5} />  <circle fill="currentColor" cx={177.705} cy={171.703} r={27.5} /></svg>
  );
}

IconScatterchart.propTypes = iconPropTypes;
IconScatterchart.defaultProps = iconDefaultProps;
